export const routesBreadcrumbConfig = [
  { path: '/backoffice/help-center', breadcrumb: 'Centro de Ajuda' },

  // Campaigns
  { path: '/backoffice/campaigns', breadcrumb: 'Campanhas' },
  { path: '/backoffice/campaigns/create', breadcrumb: 'Criar Campanha' },
  {
    path: '/backoffice/campaigns/:campaignId',
    breadcrumb: 'Detalhes da Campanha',
  },
  {
    path: '/backoffice/campaigns/edit/:campaignId',
    breadcrumb: 'Editar Campanha',
  },

  // Coupons
  { path: '/backoffice/coupons', breadcrumb: 'Cupões' },

  // Invoices
  { path: '/backoffice/invoices', breadcrumb: 'Faturas' },
  { path: '/backoffice/invoices/create', breadcrumb: 'Criar Fatura' },
  {
    path: '/backoffice/invoices/:invoiceId',
    breadcrumb: 'Detalhes da Fatura',
  },
  {
    path: '/backoffice/invoices/:invoiceId/edit',
    breadcrumb: 'Editar Fatura',
  },

  // Customers
  { path: '/backoffice/customers', breadcrumb: 'Clientes' },
  { path: '/backoffice/customers/create', breadcrumb: 'Criar Cliente' },
  {
    path: '/backoffice/customers/:customerId',
    breadcrumb: 'Detalhes do Cliente',
  },
  {
    path: '/backoffice/customers/:customerId/edit',
    breadcrumb: 'Editar Cliente',
  },
  {
    path: '/backoffice/customers/pending-consent',
    breadcrumb: 'Consentimentos de Clientes',
  },
  {
    path: '/backoffice/customers/pending-consent/:pendingConsentId',
    breadcrumb: 'Detalhes de Consentimento de Cliente',
  },
  {
    path: '/backoffice/customers/pending-consent/:pendingConsentId/edit',
    breadcrumb: 'Editar Consentimento de Cliente',
  },

  // Staff
  { path: '/backoffice/admin/staff', breadcrumb: 'Utilizadores' },
  { path: '/backoffice/admin/staff/create', breadcrumb: 'Criar' },
  {
    path: '/backoffice/admin/staff/:staffId',
    breadcrumb: 'Detalhes do Utilizador',
  },
  {
    path: '/backoffice/admin/staff/:staffId/edit',
    breadcrumb: 'Editar Utilizador',
  },

  // Shops
  { path: '/backoffice/admin/shops', breadcrumb: 'Lojas' },
  { path: '/backoffice/admin/shops/create', breadcrumb: 'Criar' },
  {
    path: '/backoffice/admin/shops/import',
    breadcrumb: 'Importar',
  },
  { path: '/backoffice/admin/shops/:shopId', breadcrumb: 'Detalhe' },
  {
    path: '/backoffice/admin/shops/:shopId/edit',
    breadcrumb: 'Editar',
  },

  // Employees
  {
    path: '/backoffice/admin/employees',
    breadcrumb: 'Funcionário Internos / Lojas',
  },
  {
    path: '/backoffice/admin/employees/create',
    breadcrumb: 'Criar',
  },
  {
    path: '/backoffice/admin/employees/import',
    breadcrumb: 'Importar',
  },
  {
    path: '/backoffice/admin/employees/:employeeId',
    breadcrumb: 'Detalhes',
  },
  {
    path: '/backoffice/admin/employees/:employeeId/edit',
    breadcrumb: 'Editar',
  },
];
